import { ThemeToggle } from './ThemeToggle';

export function Header({ copy, theme, onTheme }) {
  return (
    <header className="hd">
      <div className="hd-top">
        <div className="hd-eyebrow">
          <span className="hd-pill">{copy.product_eyebrow}</span>
        </div>
        <ThemeToggle theme={theme} setTheme={onTheme} />
      </div>
      <h1 className="hd-title">{copy.header_title}</h1>
      <p className="hd-sub">{copy.header_subtitle}</p>
    </header>
  );
}
